module.exports = __webpack_public_path__ + "media/images/flags/as-92bc418bf077a51aba4c476d8a79c198.svg";